module.exports = __webpack_public_path__ + "img/folios--icon.e0da0cf1.svg";